import getGuid from './getGuid';

export function getTraceId(): string {
    // Version is currently always 00 per the documentation.
    const Version = '00';

    // Currently the 'sampled' flag (01) is the only supported flag.
    // We are sampling so set this to 01.
    const Flags = '01';

    var traceId = getGuid().replace(/-/g, '');
    // Replaces the - with an empty string and takes the first 16 characters.
    var parentId = getGuid().replace(/-/g, '').substring(0, 16);

    return `${Version}-${traceId}-${parentId}-${Flags}`;
}

export function isTracingEnabled(actionName?: string): boolean {
    if (actionName && actionName.toLowerCase().startsWith('startupdata')) {
        return true;
    }
    return false;
}
